import { hasPermission } from "../util/permissions";

export default function PermissionGuard({
  module,
  action,
  children,
}) {
  if (!hasPermission(module, action)) {
    return null;
  }

  return children;
}

